(ns minorodata.usage-account.subs
  (:require
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 :usage-account.subs/query-cost-status
 (fn [db]
   (get-in db [:usage-account :query-cost-status])))

(re-frame/reg-sub
 :usage-account.subs/query-cost
 (fn [db]
   (get-in db [:usage-account :query-cost])))

(re-frame/reg-sub
 :usage-account.subs/previous-totals-status
 (fn [db]
   (get-in db [:usage-account :previous-totals-status])))

(re-frame/reg-sub
 :usage-account.subs/previous-totals
 (fn [db]
   (get-in db [:usage-account :previous-totals])))

(re-frame/reg-sub
 :usage-account.subs/warehouse-runtime-status
 (fn [db]
   (get-in db [:usage-account :warehouse-runtime-status])))

(re-frame/reg-sub
 :usage-account.subs/warehouse-runtime
 (fn [db]
   (get-in db [:usage-account :warehouse-runtime])))

(re-frame/reg-sub
 :usage-account.subs/heatmap-status
 (fn [db]
   (get-in db [:usage-account :heatmap-status])))

(re-frame/reg-sub
 :usage-account.subs/load-profile
 (fn [db]
   (get-in db [:usage-account :load-profile])))

(re-frame/reg-sub
 :usage-account.subs/filter-options-status
 (fn [db]
   (get-in db [:usage-account :filter-options-status])))

(re-frame/reg-sub
 :usage-account.subs/filter-options
 (fn [db]
   (get-in db [:usage-account :filter-options])))

(re-frame/reg-sub
 :usage-account.subs/shape-summary-status
 (fn [db]
   (get-in db [:usage-account :shape-summary-status])))

(re-frame/reg-sub
 :usage-account.subs/shape-summary
 (fn [db]
   (get-in db [:usage-account :shape-summary])))

(re-frame/reg-sub
 :usage-account.subs/shapes-status
 (fn [db]
   (get-in db [:usage-account :shapes-status])))

(re-frame/reg-sub
 :usage-account.subs/shapes
 (fn [db]
   (get-in db [:usage-account :shapes])))

(re-frame/reg-sub
 :usage-account.subs/query-type-series-status
 (fn [db]
   (get-in db [:usage-account :query-type-series-status])))

(re-frame/reg-sub
 :usage-account.subs/query-type-series
 (fn [db]
   (get-in db [:usage-account :query-type-series])))
